import React from "react";
import { Button, message } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import APIService from "../../services/api";

function UserExport({ id }) {
    const handleExport = async () => {
        try {
            const organizationId = id;
            message.loading('Exporting users...', 0);
            const response = await APIService.requestWithToken(
                `api/v1/organization/export-users/${organizationId}`,
                'get'
            );

            if (response?.res?.data) {
                // Convert data to CSV format
                const csvData = convertToCSV(response.res.data);

                // Create and trigger download
                const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
                const link = document.createElement('a');
                const url = URL.createObjectURL(blob);

                link.setAttribute('href', url);
                link.setAttribute('download', `users-export-${organizationId}.csv`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                message.destroy();
                message.success('Users exported successfully');
            }
        } catch (error) {
            message.destroy();
            message.error(`Failed to export users: ${error.message}`);
            console.error('Export error:', error);
        }
    };

    // Helper function to convert JSON to CSV
    const convertToCSV = (data) => {
        if (!data || !data.length) return '';

        const headers = Object.keys(data[0]);
        const rows = [
            headers.join(','), // Header row
            ...data.map(row =>
                headers.map(header =>
                    JSON.stringify(row[header] || '')
                ).join(',')
            )
        ];

        return rows.join('\n');
    };

    return (
        <Button
            type="primary"
            icon={<DownloadOutlined />}
            onClick={handleExport}
        >
            Export Users
        </Button>
    );
}

export default UserExport;